import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {RoleDto} from './dto/role.dto';
import {map} from 'rxjs/operators';
import {Role} from '../model/role';

@Injectable({
  providedIn: 'root',
})
export class RoleApiService {
  constructor(private http: HttpClient) {}

  private get url() {
    return `${environment.apiUrl}/roles`;
  }

  public getAll(): Observable<RoleDto[]> {
    return this.http.get<RoleDto[]>(this.url);
  }

  public create(displayName: string): Observable<RoleDto> {
    return this.http.post<RoleDto>(`${this.url}`, {displayName});
  }

  public update(roleId: string, role: RoleDto): Observable<RoleDto> {
    return this.http.put<RoleDto>(`${this.url}/${roleId}`, role);
  }

  public delete(roleId: string) {
    return this.http.delete(`${this.url}/${roleId}`);
  }

  public getById(roleIds: Role[]) {
    const roleIdSet = new Set(roleIds.map(activeRole => activeRole.id));
    return this.getAll().pipe(map(result => result.filter(role => roleIdSet.has(role._id))));
  }
}
